import { bluePaletteDark } from '../../themes/dark-colors';

export const scrollSnappingDarkTheme = {
  padding: '32px',
  backgroundColor: bluePaletteDark[200],
};
